import React from "react";
import { Route, Redirect } from "react-router-dom";

const DelayedRoute = ({
  component: Component,
  isPrivate,
  isReverse,
  isAdminRoute,
  isClientPage,
  ...rest
}) => {
  const accessToken = localStorage.getItem("accessToken");
  const role = localStorage.getItem("role");

  const isAuthenticated = !!accessToken;

  if (isPrivate && !isAuthenticated) {
    return <Redirect to="/login" />;
  }

  if (isReverse && isAuthenticated) {
    return <Redirect to="/me" />;
  }

  if (isAdminRoute && role !== "admin") {
    return <Redirect to="/login" />;
  }

  if (isClientPage && role === "admin") {
    return <Redirect to="/admin" />;
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default DelayedRoute;
